import { render } from "./kyc.vue?vue&type=template&id=66a2585e&scoped=true"
import script from "./kyc.vue?vue&type=script&lang=js"
export * from "./kyc.vue?vue&type=script&lang=js"

import "./kyc.vue?vue&type=style&index=0&id=66a2585e&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a2585e"]])

export default __exports__